import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const items = [
    { label: "Dashboard", path: "/admin" },
    { label: "Event Approval", path: "/admin/event-approval" },
    { label: "Financial Reports", path: "/admin/financial-reports" },
    { label: "Show Updates", path: "/admin/show-updates" },
    { label: "Show Details", path: "/admin/show-details" },
    { label: "Security Management", path: "/admin/security-management" },
    { label: "Event Flow", path: "/admin/event-flow" },
  ];

  const isActive = (p) => location.pathname === p || location.pathname.startsWith(p + "/");

  return (
    <aside
      className="fixed left-0 top-0 h-screen text-white overflow-auto"
      style={{ width: 200, background: 'linear-gradient(180deg,#071029 0%, #0b3b75 85%)' }}
    >
      {/* Sidebar Header */}
      <div>
        <div className="p-6 flex items-center gap-3">
          <div className="h-11 w-11 rounded-full bg-white/10 flex items-center justify-center text-lg font-semibold text-white/90"></div>
          <div>
            <div className="text-base font-semibold leading-tight">{user?.name || 'Admin'}</div>
            
          </div>
        </div>

        {/* Menu Section */}
        <nav className="p-2 mt-2">
          {items.map((it) => (
            <div
              key={it.path}
              className={`flex items-center rounded-md my-1 px-2 py-1 cursor-pointer transition-colors duration-150 ${isActive(it.path) ? 'bg-gradient-to-r from-blue-600/10 to-transparent' : 'hover:bg-white/5'}`}
              onClick={() => navigate(it.path)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') navigate(it.path); }}
            >
              {/* active indicator */}
              <div className="w-1 h-10 mr-3 rounded-r" style={{ background: isActive(it.path) ? '#60a5fa' : 'transparent' }} />

              <div className="flex-1 text-sm font-medium text-white/90 ml-1">{it.label}</div>

              {/* subtle chevron or empty space for alignment */}
              <div className="text-xs text-white/50 mr-2">{isActive(it.path) ? '' : ''}</div>
            </div>
          ))}
        </nav>
      </div>

      {/* Footer Section */}
      
    </aside>
  );
}
